import { Box, Grid2 } from "@mui/material";
import ImageCarousel from "../../../Components/CustomCarousel.tsx/CustomCarousel";
import { banner1, banner2, banner3 } from "../../../assets/assets";

const bannerContent = [
  {
    header: "Choose the Best Loan. Apply Now!",
    description: "The low rate you need for the need you want! Call",
  },
  {
    header: "Invest with vision",
    description:
      "Microfinance services are intended to assist socially or geographically isolated or excluded consumers, who are typically lower population segments, in becoming self-sufficient.",
  },
  {
    header: "We are here to support your",
    description:
      "Microfinance is the provision of financial services to low-income clients, such as consumers and the self-employed, who typically lack access to banks and related services.",
  },
];

const Banner = () => {
  const imgs = [banner1, banner2, banner3];
  return (
    <Box>
      <Grid2 container>
        {/* <Grid2 size={{lg:3}}>
          <Box sx={{
            background:"#F37B2C",
            width:"100%",
            height:"100%"
          }}>

          </Box>
        </Grid2> */}
        <Grid2 size={{ lg: 12 }}>
          <ImageCarousel content={bannerContent}>
            {imgs.map((image) => {
              return (
                <div>
                  <img src={image} loading="lazy" alt="banner" />
                </div>
              );
            })}
          </ImageCarousel>
        </Grid2>
      </Grid2>
    </Box>
  );
};

export default Banner;
